import { Analytics } from '@cobliteam/analytics';
import { BlueprintProvider as BlueprintProviderLib } from '@cobliteam/blueprint-react-renderer';
import { useLanguage } from '@cobliteam/i18n';
import Environment from '@cobliteam/react-environments';
import ButtonMediaDetails from '@cobliteam/ui-business/components/Button/ButtonMediaDetails';
import DialogMedia from '@cobliteam/ui-business/components/dialogs/DialogMedia';
import { useCallback, useMemo } from 'react';
import { routeRegistry } from './config/navigation';
import BlueprintRequester from './config/requester';
import useOnNavigate from './hooks/useOnNavigate';
import useOverlayMediaStore from './store/useOverlayMediaStore';

interface BlueprintProviderProps {
  children: React.ReactNode;
}

const env = Environment.getInstance().getEnvironment();

const BlueprintProvider = ({ children }: BlueprintProviderProps) => {
  const requester = useMemo(() => new BlueprintRequester({ host: env.blueprintApiHost }), []);
  const { currentLanguage: language } = useLanguage();
  const overlayMediaId = useOverlayMediaStore((s) => s.mediaId);
  const clearOverlay = useOverlayMediaStore((s) => s.clear);
  const onNavigate = useOnNavigate();
  const screen = {
    width: typeof window !== 'undefined' ? window.innerWidth : 1920,
    height: typeof window !== 'undefined' ? window.innerHeight : 1080,
  };

  const onTrackEvent = useCallback((eventName: string, properties?: Record<string, unknown>) => Analytics.track(eventName, { ...properties, source: 'blueprint' }), []);

  return (
    <BlueprintProviderLib
      config={{
        navigation: {
          routeRegistry,
          onNavigate,
        },
        requester,
        language,
        screen,
        onTrackEvent,
      }}
    >
      {children}
      {overlayMediaId && <DialogMedia mediaId={overlayMediaId} origin='Triggers' onClose={clearOverlay} redirectButton={<ButtonMediaDetails mediaId={overlayMediaId} />} />}
    </BlueprintProviderLib>
  );
};

export { BlueprintProvider };
